// @noflow
import { httpPost, httpPut } from '../helpers/helpers.api';

export function save(data) {
    if (data.id) {
        return httpPut(`/product-groups/${data.id}`, data);
    }
    return httpPost('/product-groups', data);
}



// WEBPACK FOOTER //
// ./src/core/api/product-groups/index.js